import { Card, CardContent } from "@/components/ui/card";
import { useDailyQuote } from "@/hooks/useDailyQuote";
import { Quote } from "lucide-react";

interface Props {
  compact?: boolean;
}

export function DailyQuoteCard({ compact = false }: Props) {
  const { quote, loading } = useDailyQuote();

  if (loading || !quote) return null;

  if (compact) {
    return (
      <div className="rounded-xl bg-background p-4">
        <div className="flex gap-2">
          <Quote className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm italic text-foreground/80 line-clamp-2">
              {quote.quote_text}
            </p>
            {quote.author && (
              <p className="text-xs text-muted-foreground mt-1">— {quote.author}</p>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <Card className="glass-card border-primary/10 overflow-hidden">
      <div className="absolute inset-0 bg-background" />
      <CardContent className="relative p-6 text-center space-y-3">
        <Quote className="w-8 h-8 text-primary/40 mx-auto" />
        <blockquote className="text-lg font-medium italic text-foreground/90 leading-relaxed">
          "{quote.quote_text}"
        </blockquote>
        {quote.author && (
          <p className="text-sm text-muted-foreground">— {quote.author}</p>
        )}
      </CardContent>
    </Card>
  );
}
